import Icon from '@ant-design/icons'

const SVG = () => (
    <svg
        t='1762391216581'
        class='icon'
        viewBox='0 0 1024 1024'
        version='1.1'
        xmlns='http://www.w3.org/2000/svg'
        p-id='11876'
        width='200'
        height='200'
    >
        <path
            d='M784.64 522.24a208.64 208.64 0 1 0 208.64 208.64 209.28 209.28 0 0 0-208.64-208.64z m0 344.96a136.32 136.32 0 1 1 136.32-136.32 136.96 136.96 0 0 1-136.32 136.32z'
            p-id='11877'
            fill='currentColor'
        ></path>
        <path
            d='M878.08 753.92v39.04l-70.4-31.36-80 35.84-28.8-12.8v-39.04l28.8 12.8 80-35.84 70.4 31.36z'
            p-id='11878'
            fill='currentColor'
        ></path>
        <path
            d='M878.08 751.36l-69.76-28.8-80.64 35.84-28.8-7.04v-42.24h179.2v42.24zM878.08 685.44v13.44l-70.4-30.72-77.44 35.84h-5.12l-26.24-11.52v-13.44l26.24 11.52 77.44-33.92a7.04 7.04 0 0 1 5.12 0l64 28.8a3.2 3.2 0 0 1 6.4 0z'
            p-id='11879'
            fill='currentColor'
        ></path>
        <path
            d='M878.08 745.6v16l-70.4-30.72-77.44 37.12a7.04 7.04 0 0 1-5.12 0l-26.24-11.52v-16l28.8 12.8 77.44-33.92h5.12z'
            p-id='11880'
            fill='currentColor'
        ></path>
        <path
            d='M878.08 784.64v13.44l-70.4-30.08-77.44 33.92h-5.12l-21.12-8.96v-14.08l28.8 12.8 77.44-33.92a7.04 7.04 0 0 1 5.12 0z'
            p-id='11881'
            fill='currentColor'
        ></path>
        <path
            d='M563.2 300.16l37.12 37.76-138.24 138.88-55.04-55.04a16.64 16.64 0 0 0-22.4 0L296.32 512a138.88 138.88 0 0 0-10.88 183.04 138.24 138.24 0 0 0 183.04-10.88l93.44-85.12a16.64 16.64 0 0 0 0-22.4l-55.04-55.04L645.76 384l38.4 37.76a7.68 7.68 0 0 0 10.88 0l33.92-33.92a7.04 7.04 0 0 0 0-10.88L608 256a7.04 7.04 0 0 0-10.88 0l-33.92 33.92a7.04 7.04 0 0 0 0 10.24zM428.16 640a73.6 73.6 0 0 1-94.72 8.32 73.6 73.6 0 0 1 8.32-94.72l54.4-54.4 86.4 88.32z'
            p-id='11882'
            fill='currentColor'
        ></path>
        <path
            d='M112 144v736a32 32 0 0 0 32 32h403.2a7.68 7.68 0 0 0 7.68-8.32v-55.68a7.68 7.68 0 0 0-7.68-8.32H184.32V184.32h655.36v320a8.32 8.32 0 0 0 8.32 7.68h55.68a8.32 8.32 0 0 0 8.32-7.68V144a32 32 0 0 0-32-32H144a32 32 0 0 0-32 32z'
            p-id='11883'
            fill='currentColor'
        ></path>
    </svg>
)

export const NonSeismicIcon = props => <Icon component={SVG} {...props} />
